<script>
    import Image from "./Image.svelte";
    import BlockGlobal from "./BlockGlobal.svelte";

    export let data;
</script>
<Image bind:data={data} disable={['link', 'fullscreen', 'link']}/>
<BlockGlobal bind:data={data} isCollapsable={true} isCollapsed={true}/>